<template>
    <v-container fluid class="justify-center align-center">

        <v-container fluid class="d-flex pl-0 pr-0 mr-0 ml-0 container text-orange-lighten-3 justify-center align-center"
            style="min-height: 80vh;">
            <v-row class="ma-2 pa-2 text-h3 row">
                <v-col align="center">Alle Kitten vergeben!</v-col>
            </v-row>
            <v-row class="ma-2 pa-2 text-h4 row">
                <v-col align="center">Wir planen bald weitere W&uuml;rfe</v-col>
            </v-row>
        </v-container>

        <div class="video-overlay"></div>
        <div class="video-wrap">
            <video autoplay="" loop="" muted="" class="custom-video" :poster="posterLink">
                <source :src="videoLink" type="video/mp4">

                Your browser does not support the video tag.
            </video>
        </div>
    </v-container>
</template>

<script>
export default {
    computed: {
        videoLink() {
            if (process.env.NODE_ENV === 'development') {
                return require("@/assets/static/frontpage/landingBackground.mp4")
            } else {
                return "https://static.jokingheroes.de/frontpage/landingBackground.mp4"
            }
        },
        posterLink() {
            if (process.env.NODE_ENV === 'development') {
                return require("@/assets/static/frontpage/landingBackground.jpg")
            } else {
                return "https://static.jokingheroes.de/frontpage/landingBackground.jpg"
            }
        }
    },
    mounted() { },
};
</script>

<style>
/*---------------------------------------
  VIDEO              
-----------------------------------------*/
.video-wrap {
    z-index: -100;
}

.custom-video {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.video-overlay {
    background-color: #0e171b;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    width: 100%;
    height: 100%;
    opacity: 0.4 !important;
    z-index: 2;
    opacity: 0.2;
}



.container {
    position: relative;
    z-index: 3;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 128px);
    /* Subtract height of navbar and footer */
}

.d-flex {
    flex-basis: 90%;
    flex-wrap: wrap;
}

.row {
    width: 100%;
}

a,
a:hover,
a:visited,
a:active {
    color: inherit;
    text-decoration: none;
}
</style>
